var DescriptionsItem = function (_a) {
    var children = _a.children;
    return children;
};
export default DescriptionsItem;
